// Figurinhas do Azulão (arquivos em public/stickers/<id>/)
export const STICKER_PACKS = [
  {
    id: "azulao-expressoes",
    name: "Azulão Expressões",
    short: "Expressões",
    stickers: [
      "01_oi.webp",
      "02_feliz.webp",
      "03_rindo.webp",
      "04_chorando.webp",
      "05_bravo.webp",
      "06_apaixonado.webp",
      "07_joinha.webp",
      "08_tchau.webp",
      "09_dormindo.webp",
      "10_chupchup.webp",
      "11_calor.webp",
      "12_parabens.webp",
      "13_triste.webp",
      "14_surpreso.webp",
      "15_bora.webp",
      "16_top.webp",
      "17_valeu.webp",
      "18_bomdia.webp",
      "19_fome.webp",
      "20_agua_coco.webp",
    ],
  },
  {
    id: "azulao-esportes",
    name: "Azulão Esportes",
    short: "Esportes",
    stickers: [
      "01_salva_vidas.webp",
      "02_nadador.webp",
      "03_tenista.webp",
      "04_futebol.webp",
      "05_personal.webp",
      "06_volei.webp",
      "07_beach_tenis.webp",
      "08_toto.webp",
      "09_corredor.webp",
      "10_mergulhador.webp",
      "11_pesca.webp",
      "12_surfista.webp",
      "13_ciclista.webp",
      "14_skate.webp",
    ],
  },
  {
    id: "azulao-profissoes",
    name: "Azulão Profissões",
    short: "Profissões",
    stickers: [
      "01_jardineiro.webp",
      "02_medico.webp",
      "03_pintor.webp",
      "04_professor.webp",
      "05_chef.webp",
      "06_bombeiro.webp",
      "07_garcom.webp",
      "08_musico.webp",
      "09_fotografo.webp",
      "10_programador.webp",
      "11_engenheiro.webp",
      "12_eletricista.webp",
      "13_advogado.webp",
      "14_dentista.webp",
      "15_enfermeiro.webp",
      "16_veterinario.webp",
      "17_policial.webp",
      "18_mecanico.webp",
      "19_pedreiro.webp",
      "20_encanador.webp",
      "21_carteiro.webp",
      "22_padeiro.webp",
      "23_cabeleireiro.webp",
      "24_motorista.webp",
      "25_piloto.webp",
      "26_astronauta.webp",
      "27_agricultor.webp",
    ],
  },
  {
    id: "azulao-datas",
    name: "Azulão Datas",
    short: "Datas",
    stickers: [
      "01_dia_das_criancas.webp",
      "02_natal.webp",
      "03_pascoa.webp",
      "04_carnaval.webp",
    ],
  },
];

export const stickerUrl = (packId, file) =>
  process.env.PUBLIC_URL + "/stickers/" + packId + "/" + file;
